import Dropdown from "../../components/UIElements/DropDown";
import Modal from "../../components/Misc/Modal";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import Input from "../../components/UIElements/Input";
import {
  confirmOrder,
  createProof,
  deleteOrder,
  deliverUrls,
  fulfillOrder,
  recheckOrder,
} from "../../service";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/actions";
import { useCustomSnackbar } from "../../components/Misc/useSnackbar";

const OrderDetail = ({ data, goBack }) => {
  const [value, setValue] = useState("");
  const [show, setShow] = useState(false);
  const [option, setOption] = useState("");
  const dispatch = useDispatch();
  const toast = useCustomSnackbar();
  const handleClick = async (option) => {
    dispatch(setLoading({ stat: true, text: "Handling Request" }));
    let response;
    switch (option) {
      case "recheck":
        response = await recheckOrder(data.order_id);
        if (response.statusCode === 200) {
          toast({
            type: "success",
            message: "Order has been rechedked.",
          });
        } else {
          toast({
            type: "error",
            message:
              response.statusCode === 404
                ? "Order not found"
                : "Recheck of old Stubhub orders is disabled",
          });
        }
        break;
      case "createProof":
        setShow(true);
        setOption(option);
        break;
      case "confirm":
        setShow(true);
        setOption(option);
        break;
      case "fulfill":
        response = await fulfillOrder(data.order_id);
        if (response.statusCode === 200) {
          toast({
            type: "success",
            message: "The order has been fulfilled.",
          });
        } else {
          toast({
            type: "error",
            message:
              response.statusCode === 404
                ? "Order not found"
                : "This order cannot set auto fulfill",
          });
        }
        break;
      case "deliver_urls":
        setShow(true);
        setOption(option);
        break;
      case "delete":
        response = await deleteOrder(data.order_id);
        if (response.statusCode === 200) {
          toast({
            type: "success",
            message: "The order has been deleted.",
          });
        } else {
          toast({
            type: "error",
            message:
              response.statusCode === 404
                ? "Order not found"
                : "This order cannot accept image proof.",
          });
        }
        break;
      default:
        break;
    }
    dispatch(setLoading(false));
  };
  const onSubmit = async () => {
    setShow(false);
    dispatch(setLoading({ stat: true, text: "Handling Request" }));
    let response;
    switch (option) {
      case "createProof":
        response = await createProof({ value, order_id: data.order_id });
        if (response.statusCode === 200) {
          toast({
            type: "success",
            message: "Image Proof has been created.",
          });
        } else {
          toast({
            type: "error",
            message:
              response.statusCode === 404
                ? "Order not found"
                : "This order cannot accept image proof",
          });
        }
        break;
      case "confirm":
        response = await confirmOrder({ value, order_id: data.order_id });
        if (response.statusCode === 200) {
          toast({
            type: "success",
            message: "Order has been confirmed.",
          });
        } else {
          toast({
            type: "error",
            message:
              response.statusCode === 404
                ? "Order not found"
                : response.statusCode === 500
                ? "Marketplace error."
                : "Confirm action not available due to Order status",
          });
        }
        break;
      case "deliver_urls":
        response = await deliverUrls({ value, order_id: data.order_id });
        if (response.statusCode === 200) {
          toast({
            type: "success",
            message: "Deliver URL has been set.",
          });
        } else {
          toast({
            type: "error",
            message:
              response.statusCode === 404
                ? "Order not found"
                : "This order cannot accept URLs for delivery",
          });
        }
        break;
      default:
        break;
    }
    dispatch(setLoading(false));
  };
  const getContext = () => {
    switch (option) {
      case "createProof":
        return {
          header: "Creates an image proof for the order",
          label: "The delivery proofs",
        };
      case "confirm":
        return {
          header: "Confirm Order",
          label:
            "Comma-separated list of seats to confirm with. Use when an invoice is not present, or to override invoice seat numbers. If not, an invoice must be present in the POS which is associated with the order. Example: “1,2,3,4”",
        };
      case "deliver_urls":
        return {
          header: "Deliver order manually with URLs",
          label: "The delivery URLs",
        };
      default:
        break;
    }
  };
  return (
    <div>
      <div className="flex items-center">
        <p className="font-semibold">Order Detail</p>
        <Link
          to="#"
          onClick={goBack}
          className="inline-flex items-center justify-center rounded-md border ml-auto py-1 px-4 text-white text-center font-medium hover:bg-opacity-90 lg:px-8 xl:px-10"
        >
          Go back
        </Link>
      </div>
      <div className="border rounded px-3 py-2 mt-4">
        <div className="mb-4.5 flex flex-row flex-wrap">
          {Object.keys(data).map((x, index) => (
            <div className="w-1/3 flex justify-between px-3 py-1" key={index}>
              <Typography
                variant="subtitle2"
                className="text-white underline capitalize w-full"
              >
                {x.split("_").join(" ")}
              </Typography>
              <Typography variant="subtitle2" className="w-full">
                {["order_date", "updated_at", "occurs_at"].includes(x)
                  ? new Date(data[x]).toLocaleString()
                  : data[x]}
              </Typography>
            </div>
          ))}
        </div>
      </div>
      <div className="flex mt-4">
        <Dropdown
          label="Options"
          onClick={handleClick}
          options={[
            { key: "recheck", value: "Recheck Order" },
            { key: "createProof", value: "Creat an Image Proof" },
            { key: "confirm", value: "Confirm Order" },
            { key: "deliver_urls", value: "Deliver order manually with URLs" },
            { key: "fulfill", value: "Set Order as auto fulfill" },
            { key: "delete", value: "Deletes exisiting proofs for the order" },
          ]}
          className="ml-auto"
        />
      </div>
      <Modal show={show}>
        <div className="md:px-17.5 w-full max-w-230 rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:py-15">
          <div className="mb-4.5 flex flex-col gap-6">
            <Typography variant="h5" className="text-white">
              {getContext()?.header}
            </Typography>
            <Input
              label={getContext()?.label}
              onChange={(e) => setValue(e.target.value)}
              value={value}
            />
          </div>
          <div className="-mx-3 flex flex-wrap gap-y-4">
            <div className="2xsm:w-1/2 w-full px-3">
              <button
                onClick={() => setShow(false)}
                className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
              >
                Cancel
              </button>
            </div>
            <div className="2xsm:w-1/2 w-full px-3">
              <button
                onClick={onSubmit}
                className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default OrderDetail;
